import { AccountBuilder } from './account.builder';
import { AccountService } from './account.service';

export const services: any[] = [AccountBuilder, AccountService];

export * from './account.service';
export * from './account.builder';
